import { CSSProperties, ReactNode } from 'react'

interface PageTransitionProps {
  children: ReactNode
  direction?: 'up' | 'fade'
}

const animations: Record<string, string> = {
  up: 'page-slide-up 300ms cubic-bezier(0.2, 0.9, 0.3, 1) both',
  fade: 'fade-in 250ms ease-out both'
}

export function PageTransition({ children, direction = 'up' }: PageTransitionProps) {
  const style: CSSProperties = {
    animation: animations[direction]
  }

  return <div style={style}>{children}</div>
}
